import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { Element as ReactScrollElement } from 'react-scroll';
// constants
import { SUB_CONTENT_SCROLL_ELEMENT } from './content.constants';
// components
import GameLogo from '../game-logo';
// styles
import './content.styles.less';

export const Content = (props: { children?: React.ReactNode }): JSX.Element => (
    <div className="sitegen-content-wrapper">
        <div className="sitegen-content">
            <GameLogo/>
            <ReactScrollElement className="sitegen-sub-content" name={SUB_CONTENT_SCROLL_ELEMENT}>
                {props.children}
            </ReactScrollElement>
        </div>
    </div>
);

export default translate()(Content);
